import React from "react";
import { iconProps } from "../Helper";

const HistoryIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_4681_31254)">
        <path
          d="M23 12.5C23 14.6756 22.3549 16.8023 21.1462 18.6113C19.9375 20.4202 18.2195 21.8301 16.2095 22.6627C14.1995 23.4952 11.9878 23.7131 9.85401 23.2886C7.72022 22.8642 5.76021 21.8165 4.22183 20.2782C2.68345 18.7398 1.6358 16.7798 1.21137 14.646C0.786929 12.5122 1.00477 10.3005 1.83733 8.29048C2.66989 6.28049 4.07979 4.56253 5.88873 3.35383C7.69767 2.14514 9.82441 1.5 12 1.5C14.9174 1.5 17.7153 2.65892 19.7782 4.72182C21.8411 6.78472 23 9.58262 23 12.5Z"
          stroke="#0B1216"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
        />
        <path
          d="M15.7089 15.6798L12.6089 13.8298C12.3234 13.6387 12.0862 13.3839 11.9161 13.0853C11.746 12.7868 11.6477 12.4528 11.6289 12.1098V8.00977"
          stroke="#0B1216"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
        />
      </g>
      <defs>
        <clipPath id="clip0_4681_31254">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HistoryIcon;
